module.exports = __webpack_public_path__ + "img/logo_login.2f42f615.jpg";